import React, { useState, useEffect } from 'react';
import { apiGet, apiPost, apiPut, apiDelete } from '../../../shared/utils/apiConfig';
import { useTitle } from '../../../context/TitleContext';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaPlus, FaEdit, FaTrash, FaImage, FaEye, FaToggleOn, FaToggleOff } from 'react-icons/fa';
import { showSuccessToast, showErrorToast, showWarningToast, showInfoToast } from '../../../shared/utils/toastHelper';
import axios from 'axios';
import ConfirmModal from '../../../shared/components/ConfirmModal';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const AdminBanners = () => {
    const { setTitle } = useTitle();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('home');
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [updating, setUpdating] = useState(false);
    const [confirmModal, setConfirmModal] = useState({ isOpen: false, type: '', data: null });

    const tabs = [
        { key: 'home', label: 'الرئيسية' },
        { key: 'pharmacy', label: 'الصيدليات' },
        { key: 'clinic', label: 'العيادات' },
        { key: 'doctor', label: 'الأطباء' },
        { key: 'sub_category', label: 'الفئات الفرعية' }
    ];

    useEffect(() => {
        setTitle(' البانرات');
        fetchBanners();
    }, [setTitle, activeTab]);

    const getAuthToken = () => {
        const adminData = sessionStorage.getItem('adminkhadamat');
        if (adminData) {
            try {
                const parsed = JSON.parse(adminData);
                // البحث عن التوكن في أماكن مختلفة
                if (parsed.data?.token?.access_token) {
                    const token = String(parsed.data.token.access_token);
                    return token;
                }
                if (parsed.data?.access_token) {
                    const token = String(parsed.data.access_token);
                    return token;
                }
                if (parsed.data?.token) {
                    const token = String(parsed.data.token);
                    return token;
                }
                if (parsed.token) {
                    const token = String(parsed.token);
                    return token;
                }
                return null;
            } catch (error) {
                return null;
            }
        }
        return null;
    };

    const fetchBanners = async () => {
        try {
            setLoading(true);
            const token = getAuthToken();
          
            
            if (!token) {
                throw new Error('No authentication token found');
            }
            
            const response = await axios.get(`${BASE_URL}/admin/banners?type=${activeTab}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept-Language': 'ar',
                    'lang': 'ar',
                },
            });

            const apiStatus = response.data?.status;
            const responseStatus = response.status;
            
            if (apiStatus === 'success' || apiStatus === 200 || responseStatus === 200) {
                setBanners(response.data.data || []);
            } else {
                throw new Error(response.data.message || 'فشل في جلب البانرات');
            }
        } catch (error) {
            showErrorToast(error.response?.data?.message || 'فشل في جلب البانرات');
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (banner) => {
        navigate(`/admin-edit-banner/${banner.id}`);
    };

    const handleDelete = async (bannerId) => {
        setConfirmModal({
            isOpen: true,
            type: 'delete',
            data: bannerId,
            message: 'هل أنت متأكد من حذف هذا البانر؟',
            title: 'تأكيد الحذف'
        });
    };

    const executeDelete = async (bannerId) => {
        try {
            const token = getAuthToken();
            const response = await axios.delete(`${BASE_URL}/admin/banners/${bannerId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept-Language': 'ar',
                    'lang': 'ar',
                },
            });

            const apiStatus = response.data?.status;
            if (apiStatus === 'success' || apiStatus === 200) {
                showSuccessToast('تم حذف البانر بنجاح');
                fetchBanners();
            } else {
                throw new Error(response.data.message || 'فشل في حذف البانر');
            }
        } catch (error) {
            showErrorToast(error.response?.data?.message || 'فشل في حذف البانر');
        }
    };

    const handleAddBanner = () => {
        navigate('/admin-add-banner');
    };

    const handleToggleStatus = async (bannerId, currentStatus) => {
        const newStatus = currentStatus === "1" || currentStatus === 1 ? 0 : 1;
        const confirmMessage = newStatus === 1 ? 'هل أنت متأكد من تفعيل هذا البانر؟' : 'هل أنت متأكد من إلغاء تفعيل هذا البانر؟';
        
        setConfirmModal({
            isOpen: true,
            type: 'toggleStatus',
            data: { bannerId, newStatus },
            message: confirmMessage,
            title: newStatus === 1 ? 'تأكيد التفعيل' : 'تأكيد إلغاء التفعيل',
            confirmButtonColor: newStatus === 1 ? '#28a745' : '#ffc107'
        });
    };

    const executeToggleStatus = async ({ bannerId, newStatus }) => {
        try {
            setUpdating(true);
            const token = getAuthToken();
            const response = await axios.post(`${BASE_URL}/admin/banners/${bannerId}/status?status=${newStatus}`, {}, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept-Language': 'ar',
                    'lang': 'ar',
                },
            });

            const apiStatus = response.data?.status;
            if (apiStatus === 'success' || apiStatus === 200) {
                showSuccessToast(newStatus === 1 ? 'تم تفعيل البانر بنجاح' : 'تم إلغاء تفعيل البانر بنجاح');
                fetchBanners();
            } else {
                throw new Error(response.data.message || 'فشل في تغيير حالة البانر');
            }
        } catch (error) {
            showErrorToast(error.response?.data?.message || 'فشل في تغيير حالة البانر');
        } finally {
            setUpdating(false);
        }
    };

    const handleConfirmAction = () => {
        if (confirmModal.type === 'delete') {
            executeDelete(confirmModal.data);
        } else if (confirmModal.type === 'toggleStatus') {
            executeToggleStatus(confirmModal.data);
        }
    };

    return (
        <div className="main_content">
            <div className="dashboard-container content-wrapper">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="mb-0"> البانرات</h4>
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="btn text-white d-flex align-items-center"
                        onClick={handleAddBanner}
                        style={{ borderRadius: '8px', backgroundColor: 'rgb(24, 65, 148)' }}>
                        <FaPlus className="mx-2" />
                        إضافة بانر جديد
                    </motion.button>
                </div>

                {/* Tabs */}
                <div className="card mb-4">
                    <div className="card-body">
                        <ul className="nav nav-tabs" id="bannerTabs" role="tablist">
                            {tabs.map((tab) => (
                                <li className="nav-item" key={tab.key}>
                                    <button
                                        className={`nav-link ${activeTab === tab.key ? 'active' : ''}`}
                                        onClick={() => setActiveTab(tab.key)}
                                        style={{ borderRadius: '8px 8px 0 0' }}>
                                        {tab.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Banners Table */}
                <div className="card shadow-lg border-0 card-modern">
                    <div className="card-body">
                        {loading ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-3 text-muted">جاري تحميل البانرات...</p>
                            </div>
                        ) : banners.length === 0 ? (
                            <div className="text-center py-5">
                                <FaImage className="text-muted" style={{ fontSize: '3rem' }} />
                                <p className="mt-3 text-muted">لا توجد بانرات في هذا القسم</p>
                            </div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-modern">
                                    <thead>
                                        <tr>
                                            <th className="text-center">الصورة</th>
                                            <th className="text-center">العنوان</th>
                                            <th className="text-center">النوع</th>
                                            <th className="text-center">الوصف</th>
                                            <th className="text-center">الحالة</th>
                                            <th className="text-center">الإجراءات</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {banners.map((banner) => (
                                            <tr key={banner.id} className="table-row-modern">
                                                <td className="text-center">
                                                    <div className="banner-image-container">
                                                        {banner.image ? (
                                                            <img
                                                                src={banner.image}
                                                                alt={banner.title_ar || 'بانر'}
                                                                className="banner-image"
                                                            />
                                                        ) : (
                                                            <div className="default-placeholder">
                                                                <FaImage />
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="banner-title">
                                                        <div className="fw-bold">{banner.title_ar || 'بدون عنوان'}</div>
                                                        {banner.title_en && (
                                                            <small className="text-muted">{banner.title_en}</small>
                                                        )}
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <span className="badge bg-info">
                                                        {tabs.find(t => t.key === banner.type)?.label || banner.type}
                                                    </span>
                                                </td>
                                                <td className="text-center">
                                                    <div className="banner-description">
                                                        <p className="mb-0 text-truncate" title={banner.description_ar || banner.description_en}>
                                                            {banner.description_ar || banner.description_en || 'لا يوجد وصف'}
                                                        </p>
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <span className={`badge ${String(banner.status) === '1' ? 'bg-success' : 'bg-secondary'} text-white`}>
                                                        {String(banner.status) === '1' ? 'مفعل' : 'غير مفعل'}
                                                    </span>
                                                </td>
                                                <td className="text-center">
                                                    <div className="action-buttons">
                                                        <motion.button
                                                            whileHover={{ scale: 1.1, y: -2 }}
                                                            whileTap={{ scale: 0.95 }}
                                                            className="btn btn-edit btn-action"
                                                            onClick={() => handleEdit(banner)}
                                                            title="تعديل">
                                                            <FaEdit />
                                                        </motion.button>
                                                        <motion.button
                                                            whileHover={{ scale: 1.1, y: -2 }}
                                                            whileTap={{ scale: 0.95 }}
                                                            className="btn btn-toggle btn-sm"
                                                            onClick={() => handleToggleStatus(banner.id, banner.status)}
                                                            disabled={updating}
                                                            title={String(banner.status) === '1' ? 'إلغاء التفعيل' : 'تفعيل البانر'}>
                                                            {String(banner.status) === '1' ? <FaToggleOff className="mx-1" /> : <FaToggleOn className="mx-1" />}
                                                            {String(banner.status) === '1' ? 'إلغاء تفعيل' : 'تفعيل'}
                                                        </motion.button>
                                                        <motion.button
                                                            whileHover={{ scale: 1.1, y: -2 }}
                                                            whileTap={{ scale: 0.95 }}
                                                            className="btn btn-delete btn-action"
                                                            onClick={() => handleDelete(banner.id)}
                                                            title="حذف">
                                                            <FaTrash />
                                                        </motion.button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>

            </div>

            <ConfirmModal
                isOpen={confirmModal.isOpen}
                onClose={() => setConfirmModal({ isOpen: false, type: '', data: null })}
                onConfirm={handleConfirmAction}
                title={confirmModal.title || 'تأكيد العملية'}
                message={confirmModal.message || 'هل أنت متأكد من هذا الإجراء؟'}
                confirmText="تأكيد"
                cancelText="إلغاء"
                confirmButtonColor={confirmModal.confirmButtonColor || '#dc3545'}
                type={confirmModal.type === 'delete' ? 'danger' : 'warning'}
            />
        </div>
    );
};

export default AdminBanners;

// CSS للتصميم الحديث
const style = document.createElement('style');
style.textContent = `
  /* تصميم الجدول الحديث */
  .table-modern {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    border: none;
  }
  
  .table-modern thead {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
  }
  
  .table-modern thead th {
    border: none;
    padding: 1rem;
    font-weight: 600;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  
  .table-modern tbody tr {
    border-bottom: 1px solid #f1f5f9;
    transition: all 0.3s ease;
  }
  
  .table-modern tbody tr:hover {
    background-color: #f8fafc;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .table-modern tbody td {
    border: none;
    padding: 1rem;
    vertical-align: middle;
  }
  
  /* تصميم صورة البانر */
  .banner-image-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .banner-image {
    width: 60px;
    height: 40px;
    object-fit: cover;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  /* أيقونات افتراضية للبيانات الفارغة */
  .default-placeholder {
    width: 60px;
    height: 40px;
    background: #f8fafc;
    border: 2px dashed #cbd5e1;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #94a3b8;
    font-size: 1.2rem;
    transition: all 0.3s ease;
  }
  
  .default-placeholder:hover {
    background: #f1f5f9;
    border-color: #94a3b8;
    color: #64748b;
  }
  
  /* تصميم عنوان البانر */
  .banner-title {
    font-weight: 500;
    color: #374151;
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  /* تصميم وصف البانر */
  .banner-description {
    max-width: 200px;
    color: #64748b;
    font-size: 0.875rem;
  }
  
  /* تصميم أزرار الإجراءات */
  .action-buttons {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    flex-direction: row;
    flex-wrap: nowrap;
  }
  
  .btn-edit, .btn-delete, .btn-toggle {
    border: none;
    color: white !important;
    padding: 0.25rem;
    border-radius: 8px;
    font-size: 1.2rem;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    width: 36px;
    height: 36px;
  }
  
  .btn-delete {
    font-size: 1rem;
  }
  
  .btn-edit {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);
  }

  .btn-toggle {
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    box-shadow: 0 2px 4px rgba(245, 158, 11, 0.3);
    min-width: 120px !important;
    max-width: 120px !important;
    width: 120px !important;
    font-size: 13px !important;
    text-align: center !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    padding: 8px 12px !important;
  }
  
  .btn-delete {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
    box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);
  }
  
  .btn-edit:hover, .btn-delete:hover, .btn-toggle:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
  
  .btn-edit * {
    color: white !important;
  }
  
  /* تحسين البادج */
  .badge {
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
`;
document.head.appendChild(style);
